var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('iframe',{staticClass:"iFrameFormat",attrs:{"src":`${_vm.baseUrl}/` +
            `${_vm.currentRoute}?authKey=${_vm.iFrameToken}&` +
            `organizationId=${_vm.organizationId}&clinicId=${_vm.clinicId}&` +
            `pos-tab=${_vm.activeTab}&pos-origin=${_vm.currentUrl}`,"title":"POS"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }